<template>
  <div class="flex flex-col items-center justify-center h-full">
    <h1 class="text-3xl font-bold mb-2">Трябва ти автомобил под наем?</h1>
    <p>Кажи ни за кога ти трябва, а ние ще ти кажем с какво разполагаме.</p>
    <button
      @click="emitStep"
      class="bg-active text-white font-bold rounded-full py-4 px-8 mt-6"
    >
      Избери дата
    </button>
  </div>
</template>

<script>
export default {
  name: "AppIntroduction",
  methods: {
    emitStep() {
      this.$emit("step");
    },
  },
};
</script>
